import "./ReferralSettingsPage.scss";

import Button from "components/Button/Button";
import KaboodleToaster from "components/common/KaboodleToaster";
import { useState } from "react";
import { useToken } from "utils/context";

import { useGetOrganizationSettingsQuery } from "../../services/misc-api";
import IntakeUsersTable from "./IntakeUsersTable";
import ReferralSettingsPageContainer from "./ReferralSettingsPageContainer";

const ReferralUrlDisplay = () => {
  const [copied, setCopied] = useState(false);
  const { accessToken } = useToken();
  const {
    data: orgSettings,
    isLoading,
    error,
  } = useGetOrganizationSettingsQuery(undefined, {
    skip: false,
  });

  // generate the URL if we have a valid slug
  const hasValidSlug = orgSettings?.slug && orgSettings.slug.trim() !== "";
  const referralUrl = hasValidSlug
    ? `${window.location.origin}/intake/${orgSettings.slug}/auth/register`
    : null;

  const copyToClipboard = () => {
    if (!referralUrl) return;

    navigator.clipboard
      .writeText(referralUrl)
      .then(() => {
        setCopied(true);
        KaboodleToaster.success("Referral URL copied to clipboard");
        setTimeout(() => setCopied(false), 2000);
      })
      .catch((err) => {
        console.error("Failed to copy text: ", err);
        KaboodleToaster.error("Failed to copy URL to clipboard");
      });
  };

  if (!accessToken) {
    return (
      <div className="referral-url-container card">
        <div className="card__header">Public Referral URL</div>
        <div className="card__content">
          <p>Authentication required. Please log in again.</p>
        </div>
      </div>
    );
  }

  if (isLoading) {
    return (
      <div className="referral-url-container card">
        <div className="card__header">Public Referral URL</div>
        <div className="card__content">
          <p>Loading organization settings...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="referral-url-container card">
        <div className="card__header">Public Referral URL</div>
        <div className="card__content">
          <p>Failed to load organization settings. Please try again later.</p>
        </div>
      </div>
    );
  }

  if (!hasValidSlug) {
    return (
      <div className="referral-url-container card">
        <div className="card__header">Public Referral URL</div>
        <div className="card__content">
          <p>
            Your organization doesn't have a valid URL slug configured. Please
            contact your administrator to set up a slug for your organization.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="referral-url-container card">
      <div className="card__header">Public Referral URL</div>
      <div className="card__content">
        <p>Share this URL with clients to register for the intake portal:</p>
        <div className="referral-url-box">
          <code>{referralUrl}</code>
          <Button onClick={copyToClipboard}>
            {copied ? "Copied!" : "Copy URL"}
          </Button>
        </div>
      </div>
    </div>
  );
};

const IntakeUserManagement = () => {
  return (
    <div className="user-management">
      <IntakeUsersTable />
    </div>
  );
};

const ReferralSettingsPage = () => {
  return (
    <ReferralSettingsPageContainer>
      <ReferralUrlDisplay />
      <IntakeUserManagement />
    </ReferralSettingsPageContainer>
  );
};

export default ReferralSettingsPage;
